import { initialize, t, formatHTMLMessage, formatPlurals, formatDateWithTemplate } from './provider';

export { initialize, t, formatPlurals, formatHTMLMessage, formatDateWithTemplate };

export default t;